import { DocumentsStatus } from 'generated/graphql';

export const documentsStatusList = [
  { value: DocumentsStatus.Accepted, name: 'Одобрены' },
  { value: DocumentsStatus.Rejected, name: 'Отклонены' },
  { value: DocumentsStatus.NoDocuments, name: 'Отсутствуют' },
  { value: DocumentsStatus.PartlyAccepted, name: 'Приняты частично' },
  { value: DocumentsStatus.InProgress, name: 'Требуют модерации' },
];
